var $c56d7f41f59943d7$exports = {};
$c56d7f41f59943d7$exports = {
    "clear": `Helder`,
    "invalid": `(ongeldig)`,
    "loading": `Laden...`,
    "noResults": `Geen resultaten`,
    "valid": `(geldig)`
};


export {$c56d7f41f59943d7$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
